import { Skeleton } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useCreateChartTheme } from '../../../../../theme';

ChartJS.register(ArcElement, Tooltip, Legend);

// Plugin personalizado para mostrar valores en el doughnut
const dataLabelsPlugin = {
  id: 'dataLabels',
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    ctx.font = '11px Arial';
    ctx.fillStyle = chart.options.plugins.dataLabelsPlugin?.fillStyle || '#000';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((arc, index) => {
        const data = dataset.data[index];
        // Verificar si el segmento está visible usando el estado de la leyenda
        const legendItem = chart.legend.legendItems[index];
        const isVisible = legendItem ? !legendItem.hidden : true;

        if (data > 0 && isVisible) {
          const { x, y } = arc.tooltipPosition();
          ctx.fillText(data.toLocaleString(), x, y);
        }
      });
    });
  },
};

const OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'top',
      labels: {
        usePointStyle: true,
      },
    },
  },
  scales: {
    x: {
      grid: {
        display: false, // ❌ oculta las líneas verticales
        drawBorder: false,
      },
      ticks: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false, // ❌ oculta las líneas horizontales
        drawBorder: false,
      },
      ticks: {
        display: false,
      },
    },
  },
};

export const GraficoDoughnut = ({ labels, datasets, options, ...props }) => {
  const { chartTheme } = useCreateChartTheme({
    ...OPTIONS,
    ...options,
  });

  return (
    <>
      {labels && datasets && labels.length > 0 && datasets.length > 0 ? (
        <Doughnut options={chartTheme} data={{ labels, datasets }} plugins={[dataLabelsPlugin]} />
      ) : (
        <Skeleton
          variant='rectangular'
          width={'100%'}
          height={'100%'}
          sx={{ borderRadius: '8px' }}
        />
      )}
    </>
  );
};
